var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93073 0C7.33768 0.0516026 7.74745 0.0910257 8.14189 0.211859C10.8019 1.02692 12.4282 2.82276 12.9296 5.62436C13.2315 7.31026 12.8614 8.88494 11.959 10.3247C11.8702 10.4663 11.8936 10.5353 12.0065 10.6385C13.1048 11.6426 14.1983 12.6519 15.2928 13.6603C15.4242 13.7814 15.5596 13.8987 15.6832 14.0282C16.1036 14.4689 16.1049 15.1872 15.6913 15.6362C15.2834 16.0792 14.5834 16.1285 14.1373 15.724C13.2183 14.8907 12.3087 14.0458 11.3953 13.2058C11.0509 12.8888 10.7044 12.5744 10.3634 12.2535C10.2739 12.1692 10.2064 12.1715 10.1069 12.2391C8.88135 13.0712 7.52817 13.4417 6.06583 13.3407C2.97536 13.1266 0.564292 10.758 0.0803898 7.8125C0.0522377 7.63975 0.0269009 7.46635 0 7.29295C0 6.88782 0 6.48269 0 6.07757C0.0278393 5.88846 0.0466073 5.69744 0.0850818 5.51058C0.637488 2.82019 2.19649 1.0641 4.75582 0.241346C5.18874 0.102244 5.63886 0.0522436 6.08741 0H6.93041H6.93073ZM6.50094 1.53397C3.85746 1.49519 1.49112 3.72019 1.47767 6.64135C1.46485 9.50385 3.70763 11.8202 6.47935 11.8266C9.35337 11.8333 11.5264 9.41186 11.528 6.68718C11.5298 3.85032 9.25233 1.50128 6.50062 1.53397H6.50094Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.741bf0bf55756b6275fe62551dfb47c6.svg";
export { ForwardRef as ReactComponent };